import { useParams } from 'react-router-dom';
import useFetchSpecificCampaign from 'queries/fetch/fetchSpecificCampaign.ts';
import { IterationApi } from 'schemas/CampaignApiDetails.schema.ts';
import { initialCampaign } from 'constants/campaign.ts';

/**
 * @deprecated use fetchSpecificCampaign instead, or getIterationDetailsById for iteration details
 */
function useCampaign() {
  const { teamId, campaignId } = useParams();

  const { data: campaign } = useFetchSpecificCampaign({
    teamId: teamId ?? '',
    campaignId: campaignId ?? '',
    enabled: !!campaignId && campaignId !== 'new',
  });

  const getDynamoIterationDetails = (iterationId: string): IterationApi | undefined => (
    campaign?.iteration_details?.find((iteration) => iteration.ID === iterationId) as IterationApi | undefined
  );

  return {
    campaign: campaign ?? initialCampaign,
    getDynamoIterationDetails,
  };
}

export default useCampaign;
